import { Money } from '@afterpay/types'

export const isAmountNonZero = (amount?: Money): boolean => {
  const parsedAmount = Number(amount?.amount)
  return !isNaN(parsedAmount) && parsedAmount > 0
}
